import React from 'react';
import AnalysisPanels from './AnalysisPanels';
import EditorPanel from './EditorPanel';
import RenderStatusPanels from './RenderStatusPanels';
import EditedResultPanel from './EditedResultPanel';

const EditsTab = (props) => {
    const {
        currentProject,
        isAnalysisPending,
        analysisEta,
        generationEta,
        stoppingTask,
        onStopClick,
        projectId,
        videoUrl,
        editedVideoUrl,
        videoPlayerRef,
        progressRef,
        onSourcePlay,
        onSourceError,
        onEditedPlay,
        onRecalculate,
        isRecalculating,
        editedDurationSeconds,
        editedDurationPending,
        pacedClipCount,
        calculateEditedDuration,
        estimateCreditCost,
        credits,
        isCreating,
        onCreateVideo,
        onTabChange,
        entitlements,
        editDraft,
        onEditDraftChange,
    } = props;

    const hasVideo = !!currentProject.video || isAnalysisPending;
    if (!hasVideo) {
        return (
            <div className="no-video-upload-container">
                <p>Add footage first to start editing.</p>
                <button className="btn btn-teal capsule" onClick={() => onTabChange('footage')}>
                    Go to Footage
                </button>
            </div>
        );
    }

    // Motion analysis is an INPUT to one operation, not a precondition of the
    // tab (#401). It used to replace the whole tab with a progress bar, which
    // is why "deflicker only, no analysis required" (#383) had nowhere to live.
    // Now the analysis panel sits ABOVE the operation cards: the user watches
    // analysis run and sets up the rest of the edit at the same time, and the
    // trim card explains its own pending state.
    const videoStatus = currentProject.video?.status;
    const analysisReady = videoStatus === 'analyzed' || videoStatus === 'complete';
    const showAnalysisPanels = isAnalysisPending
        || videoStatus === 'analyzing'
        || videoStatus === 'queued'
        || videoStatus === 'failed'
        || videoStatus === 'cancelled';

    return (
        <div>
            {showAnalysisPanels && (
                <AnalysisPanels
                    currentProject={currentProject}
                    isAnalysisPending={isAnalysisPending}
                    analysisEta={analysisEta}
                    stoppingTask={stoppingTask}
                    onStopClick={onStopClick}
                    projectId={projectId}
                />
            )}
            <EditorPanel
                currentProject={currentProject}
                videoUrl={videoUrl}
                videoPlayerRef={videoPlayerRef}
                onSourcePlay={onSourcePlay}
                onSourceError={onSourceError}
                onRecalculate={onRecalculate}
                isRecalculating={isRecalculating}
                editedDurationSeconds={editedDurationSeconds}
                editedDurationPending={editedDurationPending}
                pacedClipCount={pacedClipCount}
                calculateEditedDuration={calculateEditedDuration}
                estimateCreditCost={estimateCreditCost}
                credits={credits}
                isCreating={isCreating}
                onCreateVideo={onCreateVideo}
                projectId={projectId}
                entitlements={entitlements}
                editDraft={editDraft}
                onEditDraftChange={onEditDraftChange}
                analysisReady={analysisReady}
            />
            <RenderStatusPanels
                currentProject={currentProject}
                generationEta={generationEta}
                stoppingTask={stoppingTask}
                onStopClick={onStopClick}
                progressRef={progressRef}
            />
            <EditedResultPanel
                currentProject={currentProject}
                editedVideoUrl={editedVideoUrl}
                onEditedPlay={onEditedPlay}
                projectId={projectId}
            />
        </div>
    );
};

export default EditsTab;
